import styled from "styled-components";

interface FlexColumnProps {
  gap?: number;
}

export default styled.div<FlexColumnProps>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => (gap ?? false ? gap + "px" : "unset")};
`;
